import React from 'react';
import { useTranslation } from 'react-i18next';

const Home = () => {
    const { t } = useTranslation();

    return (
        <div className="page-content">
            <h1>{t('home.title')}<span className="accent">.</span></h1>
            <div className="about-content">
                <p>
                    <strong>Furkan Necati İnan</strong> {t('home.intro')} <strong>{t('home.neuralNetworks')}</strong> {t('home.and')} <strong>{t('home.computerVision')}</strong>.
                </p>

                <p>{t('home.focusAreas')}</p>
                <ul>
                    <li><strong>{t('home.areas.neuralNetworks')}</strong> - {t('home.areas.neuralNetworksDesc')}</li>
                    <li><strong>{t('home.areas.computerVision')}</strong> - {t('home.areas.computerVisionDesc')}</li>
                    <li><strong>{t('home.areas.bioinformatics')}</strong> - {t('home.areas.bioinformaticsDesc')}</li>
                    <li><strong>{t('home.areas.agenticAI')}</strong> - {t('home.areas.agenticAIDesc')}</li>
                </ul>

                <p>
                    {t('home.conclusion')}
                </p>
            </div>
        </div>
    );
};

export default Home;
